import { Injectable } from '@angular/core';
import { SnackbarType } from '../../constants/Enums';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private readonly _snackBar: MatSnackBar) { }

  public showSnackbar(type: SnackbarType,
    title: string,
    subTitle: string,
    duration?,
    verticalPosition?: any,
    horizontalPosition?: any,
    className?: any) {
    const _snackType = type ?? 'success';
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: duration || 5000,
      horizontalPosition: horizontalPosition || 'center',
      verticalPosition: verticalPosition || 'top',
      panelClass: className,
      data: { title, subTitle, snackType: _snackType, snackBar: this._snackBar }
    });
  }
}

